<button
  class="common-button__icon-sm-noborder"
  [escape]="false"
  [autoHide]="false"
  [pTooltip]="tooltipInfo.descriptionTooltip"
  [tooltipStyleClass]="'common-tooltip__big-size'"
  [tooltipPosition]="tooltipPosition"
  [tooltipDisabled]="disabled"
  [disabled]="disabled">
  <i class="lf-icon-information common-icon__md"></i>
</button>
